import { ModuleConfig } from '@/core/module';
import { systemConfigRoutes } from './routes';

export const SystemConfigModule: ModuleConfig = {
    name: 'system-config',
    routes: systemConfigRoutes,
    initialize: () => {
        console.log('System Config module initialized');
    },
};
